import { ChangeMetric } from "@similarweb/ui-components";

import { percentageSignFilter } from "app/filters/ngFilters";
import type { EPeriodSupport } from "app/UtilitiesAndConstants/UtilityFunctions/periodSupport";

import type { IMarketSizeText } from "../consts";

type ChangeText = IMarketSizeText["change"];

import { Loader } from "./Loader";

const changeValueFormatter = (value: number) => percentageSignFilter()(value, 2) as string;

interface IChangeProps {
    isLoading: boolean;
    changeData: number;
    periodSupport: EPeriodSupport;
    text: ChangeText;
}

export const Change = ({ isLoading = true, changeData, periodSupport, text }: IChangeProps) => {
    if (isLoading) {
        return <Loader />;
    }

    const changeProps = {
        value: changeValueFormatter(changeData),
        isDecrease: changeData < 0,
        unsigned: !changeData,
    };

    const labelProps = {
        displayValue: text.label[periodSupport] || text.label.monthly,
    };

    const infoTooltipProps = {
        info: text.tooltip[periodSupport] || text.tooltip.monthly,
    };

    return (
        <ChangeMetric
            changeProps={changeProps}
            labelProps={labelProps}
            infoTooltipProps={infoTooltipProps}
        />
    );
};
